<template>
  <ion-app>
    <ion-content>
      <v-container fluid id="home">
        <!-- images slider - Slideshow -->
        <div class="slider" v-show="slideshow.length > 0">
          <van-swipe :autoplay="5000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in slideshow" :key="index">
              <img :src="item.ImagePath" style="display: block; margin-left: auto; margin-right: auto; height: 100%; width: 100%;" />
            </van-swipe-item>
          </van-swipe>
        </div>

        <!-- hot classifies -->
        <div class="hot_classifies" v-show="hotClassifyList.length > 0 && $enableHotCategories">
          <div class="spacer"></div>
          <v-slide-group show-arrows v-show="$vuetify.breakpoint.mdAndUp">
            <v-slide-item v-for="(item, index) in hotClassifyList" :key="index" @click.native="onClickHotClassify(item)">
              <div class="typeList">
                <!-- <img class="" v-lazy="item.ImagePath" /> -->
                <img v-lazy="item.ImagePath" />
                <p class="item_title">{{ item.Title }}</p>
              </div>
            </v-slide-item>
          </v-slide-group>

          <v-container fluid v-show="$vuetify.breakpoint.smAndDown">
            <v-row dense justify="space-around" align="center" align-content="center">
              <v-col class="pa-1" cols="3" v-for="(item, index) in hotClassifyList" :key="index" @click="onClickHotClassify(item)">
                <v-img :src="item.ImagePath" aspect-ratio="1"></v-img>
                <p class="text-center">{{ item.Title }}</p>
              </v-col>
            </v-row>
          </v-container>
        </div>

        <!-- new arrivals -->
        <div class="spacer"></div>
        <div class="new_arrivals" v-show="newProductList.length > 0 && $enableNewProducts">
          <div class="header1">
            <label>{{ $t("home.NewArrivals") }}</label>
          </div>
          <div class="border"></div>

          <v-row dense justify="space-around" align="center" align-content="center">
            <v-col
              v-for="(item, index) in newProductList.slice(0, newItemsPerRow)"
              :key="index"
              cols="4"
              md="3"
              xl="3"
              @click="onClickNewProduct(item)"
            >
              <div class="image">
                <!-- <v-icon color="red" size="6vh" class="new">mdi-new-box</v-icon> -->
                <img v-lazy="item.ImagePath" />
                <div class="newcomer"></div>
              </div>
            </v-col>
          </v-row>

          <div style="text-align: center; margin: 10px;">
            <van-button type="default" class="more" @click="onClickNewProductList()">{{ $t("text.more") }} ></van-button>
          </div>
        </div>

        <!-- special,promote products -->
        <div class="spacer"></div>
        <div class="promo_product" v-show="promoProducts.length > 0 && $enablePromoProducts">
          <div class="header1">
            <label>{{ $t("home.Promos") }}</label>
          </div>
          <div class="border"></div>

          <div class="product_list">
            <div class="banner_picture" v-show="promoProductImages.length > 0" xslot="header">
              <img :src="promoProductImages[0]" alt="banner picture" />
            </div>

            <v-row dense justify="space-around" align="center" align-content="center">
              <v-col v-for="item in promoProducts.slice(0, itemsPerRow)" :key="item.name" cols="4" md="3" xl="3" @click="onClickPromoProduct(item)">
                <div class="product_info">
                  <div class="product_image" xslot="header">
                    <img v-lazy="item.ImagePath" />
                  </div>
                  <div class="product_content">
                    <div class="product_title">{{ item.Title }}</div>
                    <div class="product_footer" v-if="item.Price == item.SellingPrice">
                      $ <span class="product_price font_20">{{ item.Price }}</span>
                    </div>
                    <div class="product_footer_2" v-else>
                      <div>
                        $ <span class="product_price_crossout font_12">{{ item.Price }}</span>
                      </div>
                      <div>
                        $ <span class="product_price font_20">{{ item.SellingPrice }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div style="text-align: center; margin: 10px;">
              <van-button type="default" class="more" @click="onClickPromoProductList()">{{ $t("text.more") }} ></van-button>
            </div>
          </div>
        </div>

        <!-- hot products best seller-->
        <div class="spacer"></div>
        <div class="hot_product" v-show="hotProductList.length > 0 && $enableHotProducts">
          <div class="header1">
            <label>{{ $t("home.HotProducts") }}</label>
          </div>
          <div class="border"></div>

          <div class="product_list">
            <div class="banner_picture" v-show="hotProductImages.length > 0" xslot="header">
              <img :src="hotProductImages[0]" alt="banner picture" />
            </div>

            <v-row dense justify="space-around" align="center" align-content="center">
              <v-col v-for="item in hotProductList.slice(0, itemsPerRow)" :key="item.name" cols="4" md="3" xl="3" @click="onClickHotProduct(item)">
                <div class="product_info" style>
                  <div class="product_image" xslot="header">
                    <img v-lazy="item.ImagePath" />
                  </div>
                  <div class="product_content">
                    <div class="product_title">{{ item.Title }}</div>
                    <div v-if="item.Price == item.SellingPrice" class="product_footer">
                      $ <span class="product_price font_20">{{ item.Price }}</span>
                    </div>
                    <div v-else class="product_footer_2">
                      <div>
                        $ <span class="product_price_crossout font_12">{{ item.Price }}</span>
                      </div>
                      <div>
                        $ <span class="product_price font_20">{{ item.SellingPrice }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <div style="text-align: center; margin: 10px;">
              <van-button type="default" class="more" @click="onClickHotProductList()">{{ $t("text.more") }} ></van-button>
            </div>
          </div>
        </div>

        <!-- top brands feature brands -->
        <div class="spacer"></div>
        <div class="hot_brand" v-show="hotBrandList.length > 0 && $enableHotBrands">
          <img src="../assets/img/icon_hotbrand.png" alt="Brand" class="header_img" />
          <div class="header1">
            <label>{{ $t("home.BrandSelection") }}</label>
          </div>
          <div class="border"></div>

          <div class="brand_list">
            <v-row dense align="center" align-content="center">
              <v-col v-for="item in hotBrandList" :key="item.name" cols="4" md="3" xl="2" @click="onClickHotBrand(item)">
                <v-card flat xclass="card fill-height">
                  <div class="brand_info">
                    <div class="brand_image" xslot="header">
                      <img v-lazy="item.LogoPath" />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </ion-content>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      searchBoxSpan: 20, // 23,
      //cityName1: "Toronto",
      slideshow: [],
      hotProductImages: [],
      promoProductImages: [],
      hotLinks: [],
      hotClassifyList: [],

      hotBrandList: [],

      newProductList: [],
      hotProductList: [],
      promoProducts: [],
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    newItemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 6;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 4;
        case "xl":
          return 4;
      }
    },
    itemsPerRow() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 3;
        case "sm":
          return 3;
        case "md":
          return 4;
        case "lg":
          return 4;
        case "xl":
          return 4;
      }
    },
  },
  activated: function() {
    // console.log('home activated');
    if (!this.$enableCustomerService && !this.$enableShoppingCart) {
      this.searchBoxSpan = 20; // 23;
    } else if (this.$enableCustomerService && this.$enableShoppingCart) {
      this.searchBoxSpan = 14; // 17;
    } else {
      this.searchBoxSpan = 17; // 20;
    }
    this.$parent.curTab = 1;
    this.$parent.topTab = null;
    this.$parent.handleScroll(null);
  },
  mounted() {
    this.$parent.curTab = 1;
    this.$parent.topTab = null;

    this.getBannerImages();
    this.getSlideshow();
    //this.getHotLinks();
    this.getHotClassifyList();
    this.getHotBrandList();

    this.getNewProductList();
    this.getHotProductList();
    this.getPromoProductList();
  },
  methods: {
    // ------------------------------------------------------------------------ getBannerImages
    getBannerImages() {
      let $this = this;
      $this.$ajax2
        .post("GetPromoProductImages", { AppVersion: this.$version }, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.promoProductImages = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
      $this.$ajax2
        .post("GetHotProductImages", { AppVersion: this.$version }, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.hotProductImages = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getSlideshow
    getSlideshow() {
      let $this = this;
      $this.$ajax2
        .post("GetSlides", { AppVersion: this.$version }, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.slideshow = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getHotLinks
    getHotLinks() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("home"),
      };
      $this.$ajax2
        .post("GetHotLinks", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.hotLinks = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getHotClassifyList
    getHotClassifyList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
      };
      $this.$ajax2
        .post("GetHotCategories", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.hotClassifyList = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getHotBrandList
    getHotBrandList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
      };
      $this.$ajax2
        .post("GetHotBrand", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.hotBrandList = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getHotProductList
    getHotProductList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        count: 5,
      };
      $this.$ajax2
        .post("GetHotProduct", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            for (let i = 0; i < rpdata.data.data.length; i++) {
              rpdata.data.data[i].Price = rpdata.data.data[i].Price.toFixed(2);
              rpdata.data.data[i].SellingPrice = rpdata.data.data[i].SellingPrice.toFixed(2);
            }
            $this.hotProductList = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getNewProductList
    getNewProductList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        count: 10,
        instock: "true",
      };
      $this.$ajax2
        .post("GetNewProduct", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            for (let i = 0; i < rpdata.data.data.length; i++) {
              rpdata.data.data[i].Price = rpdata.data.data[i].Price.toFixed(2);
              rpdata.data.data[i].SellingPrice = rpdata.data.data[i].SellingPrice.toFixed(2);
            }
            $this.newProductList = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ getPromoProductList
    getPromoProductList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        count: 6,
      };
      $this.$ajax2
        .post("GetPromotedProduct", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            for (let i = 0; i < rpdata.data.data.length; i++) {
              rpdata.data.data[i].Price = rpdata.data.data[i].Price.toFixed(2);
            }
            $this.promoProducts = rpdata.data.data;
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------
    getNoticeList() {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
      };
      $this.$ajax2
        .post("NoticeList", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            dsBridge.call("get_notification", rpdata.data.data); // eslint-disable-line
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickSlideshow
    // show product when slideshow clicked
    onClickSlideshow(data) {
      if (data.ProductId <= 0) return;

      this.$store.commit("product", { product: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "product", params: { code: data.Code } });
    },
    // ------------------------------------------------------------------------ onClickHotBrand
    onClickHotBrand(data) {
      this.$store.commit("brandProductList", { brand: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "brandProductList", params: { code: data.Id } });
    },
    // ------------------------------------------------------------------------ onClickHotClassify
    onClickHotClassify(data) {
      let $this = this;
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        categoryId: data.IdToShow == 0 ? data.Id : data.IdToShow,
      };
      $this.$ajax2
        .post("GetCategory", obj, $this.$ajaxHeader)
        .then(function(rpdata) {
          if (rpdata.data.meta.code == "200") {
            $this.$store.commit("classifyProductList", { classify: rpdata.data.data, routeBack: true });
            // $this.$store.commit("incRouteCount");
            $this.$router.push({ name: "classifyProductList", params: { code: rpdata.data.data.Id } });
          }
        })
        .catch(function(err) {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickHotProductList
    onClickHotProductList() {
      this.$store.commit("hotProductList", { routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "hotProductList" });
    },
    // ------------------------------------------------------------------------ onClickNewProductList
    onClickNewProductList() {
      this.$store.commit("newProductList", { routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "newProductList" });
    },
    // ------------------------------------------------------------------------ onClickPromoProductList
    onClickPromoProductList() {
      this.$store.commit("promoProductList", { routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "promoProductList" });
    },
    // ------------------------------------------------------------------------ onClickHotProduct
    onClickHotProduct(data) {
      this.$store.commit("product", { product: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "product", params: { code: data.Code } });
    },
    // ------------------------------------------------------------------------ onClickNewProduct
    onClickNewProduct(data) {
      this.$store.commit("product", { product: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "product", params: { code: data.Code } });
    },
    // ------------------------------------------------------------------------ onClickPromoProduct
    onClickPromoProduct(data) {
      this.$store.commit("product", { product: data, routeBack: true });
      // this.$store.commit("incRouteCount");
      this.$router.push({ name: "product", params: { code: data.Code } });
    },
    // ------------------------------------------------------------------------
    toImageUrl(data) {
      // window.location.href= 'http://'+data.url;
      window.open("http://" + data.url);
    },
    // ------------------------------------------------------------------------ onClickCustomerServices
    onClickCustomerServices() {
      // this.$store.commit("incRouteCount");
      // this.$router.push("customerServices");
    },
  },
};
</script>

<style>
#home {
  width: 100%;
  margin-bottom: 0px;
}
#home .slider {
  margin-top: 0px; /* skip header height */
  /* max-height: 200px; */
}
#home .border {
  width: 20vh;
  height: 1px;
  background: #333;
  margin: 1% auto;
}
#home .spacer {
  height: 10px;
  background-color: #f4f4f4;
}
/* #home .header {
  height: 44px;
  line-height: 44px;
  box-shadow: 0px 2px 10px lightgrey;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: white;
} */
/* #home .header .van-row {
  --margin-left: 16px !important;
  --margin-right: 0px !important;
  height: 44px;
} */
#home .header1 {
  display: flex;
  /* height: 44px; */
  /*box-shadow: 0px 2px 10px rgb(63, 113, 194);*/
}
#home .header1 label {
  margin: auto;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
}
#home .more {
  font-size: 20px;
}

/* * * * * * * * * * * * * * new_arrivals */
.new_arrivals {
  text-align: center;
  padding-top: 1%;
  padding-bottom: 2%;
  width: 100%;
  background: white;
  color: #333;
}
.new_arrivals .image {
  flex: 1;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  width: 120%;
  vertical-align: middle;
}
.new_arrivals .image:before {
  content: "";
  display: block;
  padding-top: 80%;
}
.new_arrivals .image img {
  transition: 0.4s;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
}
#home .new {
  position: absolute;
  top: -6px;
  left: -3px;
  z-index: 1;
}

/* * * * * * * * * * * * * * hot classifies */
#home .typeList {
  height: 20vh;
  text-align: center;
  background-color: white;
  padding: 0.3%;
}
#home .typeList img {
  display: block;
  height: 70%;
  margin-top: 5%;
  padding-left: 3%;
  padding-right: 3%;
}
#home .typeList .item_title {
  word-break: break-word;
  font-size: 100%;
  text-align: center;
  overflow: visible;
  margin: 5%;
}
@media only screen and (min-width: 960px) {
  #home .typeList {
    height: 40vh;
  }
}
@media only screen and (min-width: 1264px) {
}

.hot-title {
  text-align: center;
  margin-top: 10px;
  font-weight: bold;
  color: red;
  text-transform: uppercase;
  letter-spacing: 3px;
}
.hot-product {
  width: 50%;
}

.promo-product {
  width: 50%;
  padding: 0px 2px;
}
.promo-product img {
  height: 40vw;
  object-fit: contain;
}

.bestseller-product {
  width: 50%;
  padding: 0px 2px;
}
.bestseller-product img {
  height: 40vw;
  object-fit: contain;
}

.hot-brand-product {
  width: 50%;
  padding: 0px 2px;
}

/* * * * * * * * * * * * * * specials - promo products */
#home .promo_product {
  padding-top: 1%;
  background-color: rgb(232, 243, 231);
}

/* * * * * * * * * * * * * * best sellers - hot products */
#home .hot_product {
  padding-top: 1%;
  background-color: rgb(243, 237, 231);
}

/* * * * * * * * * * * * * * hot brands */
#home .hot_brand {
  padding-top: 1%;
  background-color: #e2e7f8;
}
#home .hot_brand .header_img {
  display: block;
  margin-top: 15px;
  width: 8%;
  margin-left: auto;
  margin-right: auto;
}
#home .hot_brand .brand_list {
  padding: 5px;
}
/* #home .brand_info .brand_image {
  border: 1px solid black;
} */
#home .brand_info .brand_image img {
  display: block;
  max-height: 100%;
  max-width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
/* 
.hot_brand .product_image {
  position: relative;
  width: 120%;
  vertical-align: middle;
}
.hot_brand .product_image:before {
  content: "";
  display: block;
  padding-top: 80%;
}
.hot_brand .product_image img {
  position: absolute;
  top: 0%;
  left: 0%;
  max-width: 90%;
  max-height: 90%;
  width: auto;
  height: auto;
}
*/

/* * * * * * * * * * * * * * section banner */
#home .banner_picture img {
  display: block;
  width: 100%;
  height: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  height: 90%;
  width: 90%;
  box-shadow: 0 4px 5px -3px black;
}

/* * * * * * * * * * * * * * product content classes */
#home .product_title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

@media screen and (min-width: 600px) {
  .hot-product {
    width: 33.33%;
  }

  .promo-product {
    width: 33.33%;
  }

  .promo-product img {
    height: 25vw;
  }

  .bestseller-product {
    width: 33.33%;
  }

  .bestseller-product img {
    height: 25vw;
  }

  .hot-brand-product {
    width: 33.33%;
  }

  /* .hot-brand-product .product_info .product_image img {
    height: 25vw;
  } */
}

@media screen and (min-width: 960px) {
  .hot-product {
    width: 20%;
  }

  .promo-product {
    width: 20%;
  }

  .promo-product img {
    height: 15vw;
  }

  .bestseller-product {
    width: 20%;
  }

  .bestseller-product img {
    height: 15vw;
  }

  .hot-brand-product {
    width: 20%;
  }

  /* .hot-brand-product .product_info .product_image img {
    height: 15vw;
  } */
}

@media screen and (min-width: 1280px) {
  .hot-product {
    width: 15%;
  }

  .promo-product {
    width: 12.5%;
  }

  .promo-product img {
    height: 10vw;
  }

  .bestseller-product {
    width: 12.5%;
  }

  .bestseller-product img {
    height: 10vw;
  }

  .hot-brand-product {
    width: 12.5%;
  }

  /* .hot-brand-product .product_info .product_image img {
    height: 10vw;
  } */
}

/* .new_arrivals .image:hover img {
  transform: scale(1.4) rotate(15deg);
} */

.brandProduct {
  max-height: 100%;
  overflow-y: hidden;
  max-width: 100%;
  overflow-x: hidden;
  text-align: center;
  padding: 0px;
}
</style>
